module.exports = __webpack_public_path__ + "img/400.e890ee4e.jpg";